var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "../../Tracking", "./LinkImageList"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("../../Tracking"), require("./LinkImageList"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Tracking, global.LinkImageList);
    global.LinkImageListConcert = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _Tracking, _LinkImageList) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _LinkImageList = _interopRequireDefault(_LinkImageList);
  var cdnUrl = "https://static-cdn.arte.tv/static/styleguide/4.0.4";
  var languages = ['fr', 'de'];
  var links = {
    fr: [{
      href: 'https://www.facebook.com/ARTEConcert/',
      label: 'Facebook',
      src: "".concat(cdnUrl, "/img/next-sharebar/facebook.svg")
    }, {
      href: 'https://twitter.com/ARTEconcertFR',
      label: 'Twitter',
      src: "".concat(cdnUrl, "/img/next-sharebar/twitter.svg")
    }, {
      href: 'https://www.instagram.com/arteconcert/',
      label: 'Instagram',
      src: "".concat(cdnUrl, "/img/next-sharebar/instagram.svg")
    }, {
      href: 'https://www.youtube.com/channel/UC-smeLB9AnOTeypr1YyjJ3A',
      label: 'Youtube',
      src: "".concat(cdnUrl, "/img/next-sharebar/youtube.svg")
    }],
    de: [{
      href: 'https://www.facebook.com/ARTEConcertDE/',
      label: 'Facebook',
      src: "".concat(cdnUrl, "/img/next-sharebar/facebook.svg")
    }, {
      href: 'https://twitter.com/ARTEconcertDE',
      label: 'Twitter',
      src: "".concat(cdnUrl, "/img/next-sharebar/twitter.svg")
    }, {
      href: 'https://www.instagram.com/arteconcert/',
      label: 'Instagram',
      src: "".concat(cdnUrl, "/img/next-sharebar/instagram.svg")
    }, {
      href: 'https://www.youtube.com/channel/UC-smeLB9AnOTeypr1YyjJ3A',
      label: 'Youtube',
      src: "".concat(cdnUrl, "/img/next-sharebar/youtube.svg")
    }]
  };

  var LinkImageListConcert = function LinkImageListConcert(_ref) {
    var className = _ref.className,
        language = _ref.language,
        tracking = _ref.tracking;
    return languages.some(function (value) {
      return language === value;
    }) ? /*#__PURE__*/_react.default.createElement(_LinkImageList.default, {
      className: className,
      links: links[language],
      tracking: tracking,
      trackingEnabled: true
    }) : null;
  };

  LinkImageListConcert.propTypes = {
    className: _propTypes.default.string,
    language: _propTypes.default.oneOf(languages).isRequired,
    tracking: _propTypes.default.func
  };
  LinkImageListConcert.defaultProps = {
    className: '',
    language: 'fr',
    tracking: function tracking(_ref2) {
      var event = _ref2.event,
          href = _ref2.href,
          label = _ref2.label,
          src = _ref2.src;
      event.preventDefault();
      global.open(href);
      (0, _Tracking.send)({
        target: null,
        click_name: "".concat(label, "-concert"),
        click_type: 'exit',
        categories: ['Social_Network', 'Concert']
      });
    }
  };
  var _default = LinkImageListConcert;
  _exports.default = _default;
});